import { render, staticRenderFns } from "./viewXminfo.vue?vue&type=template&id=649e7052&scoped=true&"
import script from "./viewXminfo.vue?vue&type=script&lang=js&"
export * from "./viewXminfo.vue?vue&type=script&lang=js&"
import style0 from "./viewXminfo.vue?vue&type=style&index=0&id=649e7052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649e7052",
  null
  
)

export default component.exports